<template>
  <div>
    <div class="hero container-fluid">
      <div class="container">
        <span class="hero-heading" v-html="$t('home.title')" />
      </div>
    </div>

    <div id="accordion" class="main-accordion">
      <section
        class="main-content"
        :class="index % 2 ? 'negative' : 'positive'"
        v-for="(groupCode, index) in groupCodes"
        :key="groupCode"
      >
        <div class="container">
          <div class="card">
            <div class="card-header">
              <h1 class="mb-0 mainpage">
                <a href="#" @click.prevent class="d-block collapsed" v-b-toggle="groupCode">
                  <span v-mark-word="2">{{ groups[groupCode] }}</span>
                  <span class="icon icon-arrow-down32 float-end d-block d-md-none d-xl-none" />
                </a>
              </h1>
            </div>
            <BCollapse :id="groupCode" class="multi-collapse dont-collapse" accordion="productGroups" role="tabpanel">
              <div class="card-body">
                <div class="row">
                  <div
                    class="card-wrapper"
                    :class="classesFor(groupCode, index)"
                    v-for="(product, index) in groupedProducts[groupCode]"
                    :key="product.id"
                  >
                    <component
                      :is="`product-card${product.type ? `-${product.type}` : ''}`"
                      :product="product"
                      :subscriptionClass="product.subscriptions ? subClass : ''"
                      class="card negative"
                    />
                  </div>
                </div>
              </div>
            </BCollapse>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductCard from '../components/ProductCard';
import ProductCardSearch from '../components/ProductCardSearch';
import Banner from '../components/Banner';
import { BCollapse } from 'bootstrap-vue-next';

export default {
  components: {
    BCollapse,
    ProductCard,
    ProductCardSearch,
    Banner,
  },
  computed: {
    ...mapState('product', ['groups']),
    ...mapGetters('product', ['groupCodes', 'groupedProducts']),
    subClass() {
      return `with-subscr-${this.$i18n.locale} with-subscr-home`;
    },
  },
  methods: {
    ...mapActions('product', ['loadProducts']),
    classesFor(groupCode, index) {
      const count = this.groupedProducts[groupCode].length;

      if (count === 2) {
        return index === 0 ? 'col-sm-12 col-lg-4' : 'col-sm-12 col-lg-8';
      }

      return 'col-sm-6 col-lg-4';
    },
  },
  created() {
    this.loadProducts();
  },
};
</script>
